function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 125"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M46 14v32H14v8h32v32h8V54h32v-8H54V14z",
    style: {
      textIndent: 0,
      textTransform: "none",
      blockProgression: "tb"
    },
    fill: "currentColor",
    overflow: "visible"
  }));
}

export default SvgPlus;